import { render, staticRenderFns } from "./weChatNews.vue?vue&type=template&id=0f35e10a&scoped=true&"
import script from "./weChatNews.vue?vue&type=script&lang=js&"
export * from "./weChatNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f35e10a",
  null
  
)

export default component.exports